import { render, staticRenderFns } from "./VerticalMenu.vue?vue&type=template&id=0b8c8e53&scoped=true"
import script from "./VerticalMenu.vue?vue&type=script&lang=ts"
export * from "./VerticalMenu.vue?vue&type=script&lang=ts"
import style0 from "./VerticalMenu.vue?vue&type=style&index=0&id=0b8c8e53&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8c8e53",
  null
  
)

export default component.exports